/**
 * Attribute columns whose values are identifier-like digit strings (`id`,
 * `phone`), so a numeric value must never be rendered as a timestamp.
 */
export const ATTRIBUTES_TO_IGNORE_FOR_TIMESTAMPS: readonly string[] = ['id', 'phone'];

/**
 * Attributes that render as fixed columns and must never become dynamic
 * columns: the fixed `created_at` column honors masquerade redaction, so a
 * dynamic `custom_created_at` twin would sidestep it.
 */
export const FIXED_COLUMN_ATTRIBUTES: ReadonlySet<string> = new Set(['email', 'created_at']);

// The backend uses the same bounds in its "is a timestamp" condition.
const MIN_UNIX_TIMESTAMP = 99_999_999;
const MAX_UNIX_TIMESTAMP = 10_000_000_000;

/**
 * Whether an attribute value is a plausible unix-seconds timestamp: digits
 * only, integer, and within the backend's accepted epoch window.
 */
export function isValidTimestamp(value: string): boolean {
  if (/\D/.test(value)) return false;
  const asNumber = Number(value);
  return Number.isInteger(asNumber) && asNumber > MIN_UNIX_TIMESTAMP && asNumber < MAX_UNIX_TIMESTAMP;
}
